module.exports = __webpack_public_path__ + "img/sweden-cancer-male.97fc5300.png";